<div class="page page-fullpage">
	<img src="/assets/images/logo-octopus-splash.svg" class="octopus-logo" alt="Het logo van Octopus" title="Octopus" />
	<div class="fullpage-content-container">
		<h1>404</h1>
		<p>
			De pagina is niet gevonden.
		</p>
	</div>
</div>
